import { render, staticRenderFns } from "./memberRight.vue?vue&type=template&id=4cfe8ce2&scoped=true"
import script from "./memberRight.vue?vue&type=script&lang=js"
export * from "./memberRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe8ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cfe8ce2')) {
      api.createRecord('4cfe8ce2', component.options)
    } else {
      api.reload('4cfe8ce2', component.options)
    }
    module.hot.accept("./memberRight.vue?vue&type=template&id=4cfe8ce2&scoped=true", function () {
      api.rerender('4cfe8ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/memberRight.vue"
export default component.exports